import Axios from 'axios';
var PurInService = (function () {
    function PurInService() {
    }
    PurInService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/rejectorder/list', { params: params });
    };
    PurInService.prototype.getDetail = function (params) {
        return Axios.get('supplierclientapi/rejectorder/detail', { params: params });
    };
    PurInService.prototype.getStatus = function (params) {
        return Axios.get('supplierclientapi/rejectorder/getsupstatus', { params: params });
    };
    PurInService.prototype.confirm = function (params) {
        return Axios.post('supplierclientapi/warehouseorder/save_confirm', params);
    };
    PurInService.prototype.getListGoods = function (params) {
        return Axios.post('supplierclientapi/rejectorder/list_goods', params);
    };
    PurInService.prototype.rejectCancelOrder = function (params) {
        return Axios.get('supplierclientapi/rejectorder/cancel', { params: params });
    };
    PurInService.prototype.audit = function (params) {
        return Axios.post('supplierclientapi/rejectorder/audit', params);
    };
    PurInService.prototype.latestSignImg = function (params) {
        return Axios.get("supplierclientapi/rejectorder/latest_sign_img", { params: params });
    };
    PurInService.prototype.getSignStatus = function (params) {
        return Axios.get("supplierclientapi/rejectorder/get_sign_status", { params: params });
    };
    PurInService.prototype.saveRejectOrder = function (params) {
        return Axios.post('supplierclientapi/rejectorder/save', params);
    };
    PurInService.prototype.orderImgById = function (params) {
        return Axios.get("supplierclientapi/rejectorder/order_img_list", { params: params });
    };
    PurInService.prototype.orderDetailImg = function (params) {
        return Axios.get("/supplierclientapi/rejectorder/order_detail_img_list", { params: params });
    };
    PurInService.createInstance = function () {
        PurInService.getInstance();
    };
    PurInService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    PurInService.prototype.getSignList = function (params) {
        return Axios.get("supplierclientapi/warehouseorder/sign_img_list", { params: params });
    };
    return PurInService;
}());
export default PurInService;
